const Constant = {
	crud: {
		create: 'CREATE',
		update: 'UPDATE',
		delete: 'DELETE',
	},
	cloud_name: 'duxzkjxo5',
	api_url_upload_img: process.env.REACT_APP_CLOUDINARY_UPLOAD || '',
	api_url_destroy_img: process.env.REACT_APP_CLOUDINARY_DESTROY || '',
	api_key: 287483298955728,
	upload_preset_value: process.env.REACT_APP_CLOUDINARY_PRESET || '',
	categories_new: [
		{
			value: 'Công ty',
		},
		{
			value: 'PCCC',
		},
		{
			value: 'Trang phục tác chiến',
		},
		{
			value: 'Phương tiện tác chiến',
		},
		{ value: 'Defire' },
		{ value: 'Gsafe' },
		{ value: 'Defender' },
		{ value: 'Tàu BK' },
		{ value: 'Tàu điện' },
		{ value: 'Hợp tác và phát triển' },
	],
	apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3010',
	apiKey: process.env.REACT_APP_API_KEY || '5b5c54c3b8a36de3ae2b1ee7430e14fa',
};
export default Constant;
